exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1twgmqRFXcztMrashVJqMD{width:100%}._3Hr8h34P63dGPfA8Irbzbt{font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:1.14286rem;font-weight:600;letter-spacing:.07143rem;line-height:1.125;margin:0;padding-bottom:.71429rem}.hyzlm-bfvFH8l3QrEWTZQ{min-height:2.5rem}@media only screen and (min-width:480px){._29giXtsTqC5AuYTFmuItfE{padding-right:1.42857rem}}@media only screen and (min-width:640px){._29giXtsTqC5AuYTFmuItfE{padding-right:2.14286rem}}._3PYC6C__-LQpyKExhQanFF{padding-bottom:.71429rem}.FiQFW1X490ujeMhA2Bm1N{padding-bottom:1.07143rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"SkillSuggestionCard_board": "_1twgmqRFXcztMrashVJqMD",
	"SkillSuggestionCard_h5": "_3Hr8h34P63dGPfA8Irbzbt",
	"SkillSuggestionCard_select_option": "hyzlm-bfvFH8l3QrEWTZQ",
	"SkillSuggestionCard_item": "_29giXtsTqC5AuYTFmuItfE",
	"SkillSuggestionCard_skillResult": "_3PYC6C__-LQpyKExhQanFF",
	"SkillSuggestionCard_skillResult_indexLabel": "FiQFW1X490ujeMhA2Bm1N"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/_omni-operation-ui_release_2.7.2/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/ProgressReportHFv4/IndividualDevelopmentPlanDetailView/FeedbackSuggestions/SkillSuggestionCard/style.postcss
// module id = 1999
// module chunks = 0